{
  "title": "Spray Of Cards",
  "source": "The Book of Many Things",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self (15-foot cone)",
  "components": "V, S, M (a deck of cards)",
  "duration": "Instantaneous",
  "description": [
    "You spray a 15-foot cone of spectral cards. Each creature in that area must make a Dexterity saving throw. On a failed save, a creature takes 2d10 force damage and has the blinded condition until the end of its next turn. On a successful save, a creature takes half as much damage only.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d10 for each slot level above 2nd."
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
